import { BaseDto } from "../base/baseDto.model"

export class ContratoGarantiaDto{
    public idGarantia: number = 0
}

export class ContratoGarantiaSumaryDto{
    public idGarantia: number = 0
    public persona: BaseDto =  new BaseDto    
}